var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.973 18.1697L9.51305 15.7097C9.12305 15.3197 8.49305 15.3197 8.10305 15.7097C7.71305 16.0997 7.71305 16.7297 8.10305 17.1197L11.273 20.2997C11.663 20.6897 12.293 20.6897 12.683 20.2997L15.853 17.1297C16.243 16.7397 16.243 16.1097 15.853 15.7197C15.463 15.3297 14.833 15.3297 14.443 15.7197L11.973 18.1697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0074 5.92749L14.4674 8.38749C14.8574 8.77749 15.4874 8.77749 15.8774 8.38749C16.2674 7.99749 16.2674 7.36749 15.8774 6.97749L12.7074 3.79749C12.3174 3.40749 11.6874 3.40749 11.2974 3.79749L8.12742 6.96749C7.73742 7.35749 7.73742 7.98749 8.12742 8.37749C8.51742 8.76749 9.14742 8.76749 9.53742 8.37749L12.0074 5.92749Z",
    fill: "#668295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnSortDown);
export default __webpack_public_path__ + "static/media/column-sort-down.d969c6d851afa2e0194964063b6d0bb8.svg";
export { ForwardRef as ReactComponent };